/** Invoice list flags — mirrors Patients clinical form mark UX (Reviewed → Paid). */
import { EvaluationIcon, PayrollIcon } from "../../Icons";

export const INVOICE_MARKS = [
  {
    type: "Reviewed",
    code: "R",
    label: "Reviewed",
    color: "#d97706",
    Icon: EvaluationIcon,
  },
  {
    type: "Paid",
    code: "Paid",
    label: "Paid",
    color: "#16a34a",
    Icon: PayrollIcon,
  },
];

export const INVOICE_MARK_ORDER = INVOICE_MARKS.map((m) => m.type);

export const getInvoiceMarkMeta = (markType) =>
  INVOICE_MARKS.find((m) => m.type === markType) || {
    type: markType,
    code: String(markType || "?").slice(0, 3),
    label: markType || "Unknown",
    color: "#64748b",
    Icon: EvaluationIcon,
  };

/** Fixed slots so Flags align across rows: Reviewed | Paid. */
export const buildAlignedInvoiceMarkSlots = (marks = []) => {
  const byType = new Map();
  (marks || []).forEach((m) => {
    const type = m.markType || m.type;
    if (type && !byType.has(type)) byType.set(type, m);
  });
  return INVOICE_MARK_ORDER.map((type) => ({
    type,
    mark: byType.get(type) || null,
  }));
};

/** Once Reviewed or Paid is set, employees cannot edit (Admin/OA still can). */
export const isInvoiceEditLocked = (invoice) => {
  const marks = invoice?.marks || [];
  return marks.some((m) => {
    const type = m.markType || m.type;
    return type === "Reviewed" || type === "Paid";
  });
};

/** True if invoice currently has this flag. */
export const invoiceHasMark = (invoice, markType) =>
  (invoice?.marks || []).some((m) => (m.markType || m.type) === markType);

/**
 * For selected invoices:
 * - none have mark → apply
 * - all have mark → remove
 * - mixed → both (show Apply + Remove)
 */
export const selectionMarkMode = (invoices, selectedIds, markType) => {
  const selected = (invoices || []).filter((inv) => selectedIds?.has(inv.id));
  if (!selected.length) return "apply";
  const withMark = selected.filter((inv) => invoiceHasMark(inv, markType)).length;
  if (withMark === 0) return "apply";
  if (withMark === selected.length) return "remove";
  return "both";
};
